import { ROUTE_CONST } from "./route.constant.js";

const getApplicationName = () => {
  return "BlueVerse Foundry";
};

export const APP_CONST = {
  APPLICATION_NAME: getApplicationName(),
  LTIMINDTREE: "LTM",
  CHUNK_RELOAD_KEY: "chunk_reload_count",
  MAX_CHUNK_RELOAD_ATTEMPTS: 5,
  ERROR_PROCESSING_REQUEST:
    "There was an error processing your request. Please contact support",
  NO_VIDEOS_FOUND: "No videos found",
  COPIED_TO_CLIPBOARD: "Copied to clipboard",
  ERROR: "error",
  NOT_AVAILABLE: "N/A",
  CHAT_APP: "ChatApp",
  CHAT_LITE: "ChatLite",
  CHAT_LITE_OPEN: "ChatLiteOpen",
  NO_ASSISTANTS_FOUND: "There are no Assistants",
  NO_AGENTS_FOUND: "There are no Agents",
  NO_PROCESS_FOUND: "There are no Processes",
  NO_RAGS_FOUND: "There are no RAG Pipelines",
  NO_PROCESSES_FOUND: "There are no Processes",
  AGENTS_PAGE_DESCRIPTION: "Search, Discover & Interact with Agents",
  AGENTS_SEARCH: "Search for agents",
  DISCOVER_TAG: "Expanding every week with new Digital Employees",
  DISCOVER_TITLE: [
    "Explore the comprehensive marketplace featuring over",
    "Assistants, Agents, Processes and RAGs",
  ],
  HOME_DISCOVER_TITLE: [
    "Meet Your Digital Employee",
    "Intelligent, AI Powered, Reliable and Always ready!",
  ],

  MARKETPLACE_STATS: [
    "24/7 Availability",
    "Wide range of spoken language and accents",
    "Always responsible and ethical, with BlueVerse guardrails",
  ],

  DISCOVERY_CATEGORIES: ["Assistants", "Agents", "Processes", "RAG Pipelines"],
  DISCOVERY_ORIGIN_CATEGORIES: ["assistants", "agents", "processes", "rags"],
  APP_FOUNDRY: "Studio",
  TABS_HEADERS: [
    { path: ROUTE_CONST.MYTEAM, title: "MyTeam" },
    { path: ROUTE_CONST.ASSISTANTS, title: "Assistants" },
    { path: ROUTE_CONST.DIGITAL_EMPLOYEE, title: "Digital Employee" },
    { path: ROUTE_CONST.AGENTS, title: "Agents" },
    { path: ROUTE_CONST.PROCESSES, title: "Processes" },
  ],

  CANVASAI_SOLUTIONS: [
    {
      title: "Identify, configure access to data for the solutions",
      description:
        "Unstructured content in multiple formats, scattered. Structured content is highly secured and from multiple sources",
      subtitles: [
        {
          heading: "Content Hub",
          desc: "To catalogue all the scattered artefacts, control access",
        },
        {
          heading: "Data usage Insights",
          desc: "Data to use case lineages, consumption events",
        },
        {
          heading: "Access Control",
          desc: "Full control over who and how the artefacts are used by AI solutions",
        },
      ],
    },
    {
      title: "Build AI Agents, Assistants",
      description: `Compose AI Agents, Assistants, Business processes powered by AI Agents with ${getApplicationName()}'s designer`,
      subtitles: [
        {
          heading: "No-code Designer",
          desc: "Build RAGs, Agents and Flows for Assistants with no code",
        },
        {
          heading: "Pro-code Editor",
          desc: "Add modifications to created Agents and Assistants through a code editor",
        },
        {
          heading: "Marketplace",
          desc: "Comprehensive catalogue of vertical and horizontal AI Agents, AI Tools, Process templates, RAG Pipelines, Test suites, SLM & LLMs",
        },
      ],
    },
    {
      title: "Democratize & Scale",
      description:
        "New metrics for scaling: Token throughput, Token management",
      subtitles: [
        {
          heading: "Kits",
          desc: "Ready to use UX kits (Search, Chat, Batch etc.)",
        },
        {
          heading: "App Gallery, Labs",
          desc: "Entitlement based app galleries",
        },
        {
          heading: "AI Economics",
          desc: "Budget, rate limit, reporting",
        },
        {
          heading: "Auditability",
          desc: "Full stack observability, metrics, events, logs and traces",
        },
      ],
    },
    {
      title: "Quality Assurance for AI",
      description: `AI testing for AI Agents, Assistants, RAG Pipelines with ${getApplicationName()}'s AI Quality Assurance services`,
      subtitles: [
        {
          heading: "LLM Response Evaluation",
          desc: "Test prompt-responses, identify drift, manage hallucinations",
        },
        {
          heading: "Moderation",
          desc: "For both prompts and responses; rule based and free form",
        },
        {
          heading: "Lineage Tracker",
          desc: "Cite the sources",
        },
      ],
    },
  ],
  CANVASAI_FEATURES: [
    {
      title: "CIO/CTO",
      features: [
        {
          title: "Flexible AI Architecture",
          description:
            "AI Strategy & a landing zone plugging in best of AI Services there is today",
        },
        {
          title: "Interoperability with AI Hub",
          description:
            "Bring-in Agents, MCP Servers, AI Tools, LLMs & SLMs from multiple sources & cloud into Foundry",
        },
        {
          title: "Control Plane",
          description:
            "Fine-grained tokenomics at AI Solution and User level, full-stack observability, centralized Responsible AI control",
        },
      ],
    },
    {
      title: "Creators",
      features: [
        {
          title: "Speed & low skill barrier",
          description:
            "Compose with Assets from Marketplace (hub), No code, Pro code",
        },
        {
          title: "Accuracy & Explainability",
          description: "AI Evaluation, Contextualized SLMs, Knowledge Fabric",
        },
        {
          title: "Consistent User Experience",
          description:
            "Last mile user experience kits like Chat, Search, Mobile Applications for Corp App Store",
        },
      ],
    },
    {
      title: "End Users",
      features: [
        {
          title: "Single Store Front",
          description:
            "Discover and consume all AI assets based on role entitlement",
        },
        {
          title: "Via multiple channels",
          description:
            "Web, Mobile, Tablets, Voice and through Backend Processes - AI is delivered at the point of consumption",
        },
        {
          title: "Role based access control",
          description:
            "Units as isolations, Each asset is access-controlled with SSO integration",
        },
      ],
    },
  ],
  PARTNERS: ["aws", "azure", "nvidia", "ibm"],
  COPYRIGHT_TEXT: `2025 © LTIMindtree All Rights Reserved`,
  MODAL_POPUP_TABS: ["Profile", "Performance", "Resources", "Used Assets"],
  DIGITAL_PROFILE: "Digital Profile",
  MODELS_TITLE: "AI Models powering this Agent",
  MODELS: "Models",
  COMPLIANCE_INFO: "Compliance Info",
  URL_LINKS: "URL Links",
  PUBLISHER: "Publisher :",
  DESCRIPTION: "Description",
  OWNER: "Owner :",
  TYPE: "Type",
  RATING: "Rating :",
  CHAT_WITH_ME: "Chat with Me",
  TALK_WITH_ME: "Talk with Me",
  CALL_ME_OVER_API: "Call me over API </>",
  ACCURACY_SCORE: "Accuracy Score",
  INDUSTRY_ACCREDITATIONS: "Industry Accreditations",
  RATE: "Rate",
  WHO_AM_I: "Who am I?",
  TARGET_INDUSTRY: "Target Industry",
  WHAT_CAN_I_DO: "What can I do?",
  SKILLS: "Skills",
  GAIN: "Gain",
  BASE_KIT: "Base Kit",
  AVERAGE_SESSION_TIME: "Average Session Time",
  COST_PER_SESSION: "Cost per session",
  PROVISIONED_THROUGHPUT: "Provisioned throughput",
  API: "API",
  RAG_PIPELINES_HEADING: "Search & Discover your RAG Pipelines",
  PROCESSES_HEADING: "Search & Discover your Processes",
  INTRO_DISCOVER: "Discover More",
  WHAT_IS_APPLICATION_NAME: `What is ${getApplicationName()}?`,
  DESCRIPTION_TEXT: `${getApplicationName()} is an enterprise-grade AI Platform designed to accelerate the concept-to-value journey while solving last-mile challenges in adopting Agentic AI. Designed to run on Multi & Hybrid Cloud setups, it enables seamless interoperability across agents, models, and tools from diverse cloud ecosystems while maintaining consistent guardrails, governance, security, and control. ${getApplicationName()} empowers organizations to harness advanced AI capabilities responsibly and efficiently, transforming how businesses deploy and scale intelligent solutions`,
  BUILD_SECTION_TITLE: "Marketplace: Scaling made simple",
  THE_APPNAME: `Why ${getApplicationName()}?`,
  BUILD_SECTION_DATA: [
    {
      title: "Explore",
      description: `Choose from thousands of Agents, Assistants, Tools and other assets that are relevant to your business requirements`,
    },
    {
      title: "Role based catalogue",
      description:
        "Find, launch and interact with text or voice, across multiple channels and devices",
    },
    {
      title: "Omnichannel",
      description:
        "Access Agents, AI Assistants and solutions accessible across web, mobile, or chat platforms like Teams, Slack",
    },
  ],
  CONNECT_MAIL: "Reach out to us via Email",
  LABS_HEADING: "Labs and Marketplace",
  LAUNCH_PROCESS: "Launch Process",
  PREVIEW_FILE: "Preview File",
  SIGN_OUT: "Sign out",
  BACK: "Back",
  UNITS_DATA: "unitsData",
  SELECTED_UNITS_DATA: "selectedUnitsData",
  UNITS: "Units:",
  FILTER_BY_UNITS: "Filter by Units",
  CHAT: "Chat",
  SEARCH_APPS: "Search Apps",
  DOCUMENT: "Document",
  CODE: "Code",
  CREATIVE: "Creative",
  SELECT_UNITS: "Select Units",
  SEARCH: "Search",
  LAUNCH_TEXT: "Launch",
  INTERACT: "Interact",
  CATELOGUE_AGENT: "Catalogue Agent",
  SHOWING: "Showing",
  OUT_OF: "out of",
  SOMETHING_WENT_WRONG_WITH_COPY: "Copy failed. Please try again",
  FILE_DOWNLOADED_SUCCESSFULLY: "File Downloaded Successfully",
  VIDEO_DOWNLOADED_SUCCESSFULLY: "Video Downloaded Successfully",
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again",
  API_URL: "API URL",
  REQUEST_BODY: "Request Body",
  RESPONSE_BODY: "Response Body",
  DISCOVER_CARD_DATA: [
    "Assistants / Copilots",
    "Agents",
    "Processes",
    "RAG Pipelines",
  ],
  REACH_OUT: "Reach out to us!",
  MAIL_TO: "mailto:Blueversefoundry.Support@ltimindtree.com",
  STUDIO: "Start creating with the Studio",
  MARKETPLACE: "Marketplace",
  FOUNDRY_SUBHEADING: [
    `${getApplicationName()} addresses last-mile challenges across the enterprise,`,
    "for each key personas in their AI journey.",
  ],
  CREDITS: "Credits :",
  OTHERS: "Others",
  DIRECT_ASSISTANT: "Direct Assistant",
  API_BASED_DIRECT_ASSISTANT: "API Based Direct Assistant",
  KIT_ASSISTANT: "Kit Based Assistant",
  UNIT: "Unit",
  LIKE: "Like",
  LIKES: "Likes",
  COPY: "Copy",
  NO_ASSETS_FOUND: "No Assets Found",
  DIRECT_ASSISTANT_ASSETS: "Direct assistant does not use any assets",
  WHAT_WOULD_YOU_LIKE_TO_SEARCH_FOR: "What would you like to search for?",
  USER_ID: "userId",
  BEARER_TOKEN: "Bearer Token",
  CLICK_HERE_BEARER_TOKEN: "Click here to copy bearer token",
  ASSISTANTS_TITLE:
    "Search and discover AI-powered Assistants that combine organizational knowledge and domain expertise",
  ASSISTANTS_SEARCH: "Search by assistants",
  DIGITAL_EMPLOYEE_MARKETPLACE_TITLE:
    "Search, hire and manage AI-powered Digital Employees that perform specialized roles and execute business tasks end-to-end.",
  DIGITAL_EMPLOYEE_SEARCH: "Search by Role/Job Description",
  NO_DIGITAL_EMPLOYEES_FOUND: "There are no Digital Employees",
  HIRED_DIGITAL_ASSISTANTS: "Team of Hired Digital Assistants",
  TRUE: "true",
  HIRING_STATES: {
    TEMP: { code: 0, label: "Hire as Temp", nextCode: 1 },
    PERMANENT: { code: 1, label: "Hire as Permanent", nextCode: 2 },
    RETIRED: { code: 2, label: "Retire", nextCode: 3 },
    DEFAULT: { code: 0, label: "Hire as Temp", nextCode: 1 },
  },
  DIGITAL_MINDS: "Digital Minds.",
  HUMAN_PURPOSE: "Human Purpose.",
  DIGITAL_EMPLOYEE_TAGLINE:
    "Your team of AI Agents: Your Insightful Partners in Reimagining Work!",
  SEND_US_YOUR_FEEDBACK: "Send us your Feedback!",
  GOT_SUGGESTIONS: "Got suggestions? We'd love to hear them!",
  SEND_FEEDBACK: "Send Feedback",
  FEEDBACK_PLACEHOLDER: "Write your feedback here...",
  JOB_TITLE: "Job Title",
  LEVEL: "Level",
  REGION: "Region",
  BASIC_INFO: "Basic Info",
  PERFORMANCE: "Performance",
  RESOURCES: "Resources",
  TAGS: "Tags",
  CALL_ME: "Call Me",
  URL: "URL",
  RETIRE: "Retire",
  SUCCESSFULLY_RETIRED: " has been successfully retired",
  ARE_YOU_SURE_RETIRE: "Are you sure you want to retire ",
  EXPLORE_BUTTON_TITLE: "Explore",
  MY_TEAM: "My Team",
  GOTO_HOME_TEXT: "Go back to Home Page",
  // KEYCLOAK STORAGE KEYS - LocalStorage keys for Keycloak authentication
  KEYCLOAK_STORAGE_KEYS: {
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    EXP: "exp",
    IAT: "iat",
    EMAIL_ID: "emailId",
    USER_NAME: "user_name",
    AUTH_SERVER_ID: "authServerId",
    USER_ID: "userId",
    LOGGED_IN: "loggedIn",
    FULL_NAME: "full_name",
    USER_GROUPS: "user_groups",
    USER_PERSONA: "user_persona",
    IS_ADMIN: "isAdmin",
  },
  // KEYCLOAK CONFIGURATION - Token refresh and validation settings
  KEYCLOAK_CONFIG: {
    TIME_TO_REFRESH: 60, // seconds before token expiry to trigger refresh
    IDLE_TIME_THRESHOLD: 40 * 60, // 40 minutes in seconds - auto logout after inactivity
    REFRESH_INTERVAL: 60000, // 60 seconds in milliseconds - interval to check token refresh
    TOKEN_UPDATE_BUFFER: 70, // seconds - buffer time for token update
  },
  ADMIN: "Admin",
  TRAIN_EMPLOYEE: "Train Employee",
  DETAILS_SAVED_SUCCESSFULLY: "Details saved successfully",
  SHOW_ONLY_DIGITAL_PROFILE: "Show only Assistants with Digital Profile",
  TEACH_POPUP: {
    TITLE: "Train Employee",
    SUBTITLE:
      "Enhance your assistant's capabilities with information that helps users in their job",
    LABEL: "Label",
    INSTRUCTIONS: "Instructions",
    VALUE: "Value",
    LABEL_PLACEHOLDER: "Enter Label",
    VALUE_PLACEHOLDER: "Enter Value",
    SUBMIT: "Submit",
    CANCEL: "Cancel",
  },
};
